<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import { saleService } from "../../../services/saleservice/sale.service";
import { scheduleService } from "../../../services/saleservice/schedule.service";
import { servicehelpers } from "../../../services/servicehelpers";
import { commissionService } from "../../../services/saleservice/commission.service";
import i18n from "../../../i18n";
import Loading from "@/components/c-loading";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Button from "@/components/c-button";
import PaymentTerm from "../../../components/modals/payment-term.vue";
import List from "../../../components/list";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Sale Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Input,
    Select,
    Search,
    Loading, 
    Button,
    PaymentTerm,
    List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      title: "Sale",
      saleData: null,
      breadCrumb: {},
      dataDiscountText: '',
      property: {},
      dataProject: 0,
      propertySelected: {},
      bookingSelected: {},

      lastPayTypeData: {},
      customerList: {},
      templeteList: {},
      projectList: {},
      propertyList: {},
      currencyList: {},
      discountTypeList: {},
      commissionTypeData: {},
      commissionData: {},
      existCommission: false,
      sellerData: {},
      agencyData: {},

      dataCode: '',
      dataCustomer: 0,
      dataTemplate: 0,
      dataAccountTender: 0,
      dataProperty: 0,
      dataCurrency: 0,
      dataAmount: 0,
      dataDiscount: 0,
      dataDiscountType: 0,
      dataSalePrice: 0,
      dataDeposit: 0,
      dataInterest: 0,
      dataPaymentTerm: 0,
      dataManualSettle: 0,
      dataSeller: 0,
      dataAgency: 0,
      dataCommission: 0,
      dataCommissionAmount: 0,
      dataCommissionFor: 0,
      dataPaymentStatus: 0,
      dataStartDate: '',
      dataDate: '',
      dataDoc: [],

      dataSchedule: [],

      paymenttermData: {},
      scheduleList: {},
      principle: 0,
      selectedSchedule: 0,
      selectChangePaymentTerm: null,
    
      user: JSON.parse(localStorage.getItem('user')),
      seller: JSON.parse(localStorage.getItem('seller')),

      dataLastPaytype: 0,
      dataNoInterestPayment: 0,
      dataNoInterestDuration: 0,
    };
  },
  mounted() {

    this.loadingCurrencyData();
    this.loadingDiscountTypeData();
    this.loadingCommissionData();

    this.dataCurrency = 1;
    this.dataDiscountType = 2;
    this.dataDiscountText = "សា​ច់ប្រាក់";

    this.loadingData(this.$route.params.id);
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      saleService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: i18n.t('sale.text') + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.saleData = response;

          this.dataCode = this.saleData.data.code;
          this.dataDate = this.saleData.data.sale_date;
          this.dataTemplate = this.saleData.data.template_id;
          this.dataCustomer = this.saleData.data.customer_id;
          this.dataProperty = this.saleData.data.property_id;
          
          this.dataSalePrice = this.saleData.data.sale_price;
          this.dataDeposit = this.saleData.data.sale_amount;
          this.dataDiscount = this.saleData.data.discount;
          this.dataDiscountType = this.saleData.data.discount_type;
          this.dataBookingAmount =  this.saleData.data.deposit ? this.saleData.data.deposit : 0;
          //this.dataAmount = this.dataSalePrice - this.dataBookingAmount; //this.saleData.data.amount;
          this.dataAmount = this.saleData.data.amount;
          this.dataLastPaytype = this.saleData.data.last_pay_type_id;


          this.dataNoInterestPayment = this.saleData.data.no_interest_payment;
          this.dataNoInterestDuration = this.saleData.data.no_interest_duration;

          this.title = i18n.t('sale.text') + " - (" + this.saleData.data.code + ")";

          scheduleService.preview(id)
            .then(response => {
              this.fetchingStats = true;
              this.scheduleList = response;

              let pending = this.scheduleList.data.filter(item => item.note == 'Pending');
              let first = pending[0];
              this.principle = first ? first.principal : 0;  
              this.selectedSchedule = first ? first.id : 0;
            
            });

          this.loadingSettings(response.setting);
        });
    },

    loadingCurrencyData: function() {

      servicehelpers.getCurrencyData().then(response => {
        this.currencyList = response;
      });
    },
    loadingDiscountTypeData: function() {

      servicehelpers.getDiscountTypeData().then(response => {
        this.discountTypeList = response;
      });
    },

    paymenttermChange: function(event) {
      // console.log("TEST", event);
      if(event == 1) {
        this.$refs['payment-term'].show();
      } else {

        servicehelpers.getPaymentSchedule(event).then(response => {
          this.paymentSchedule = response;
          this.generateSchedule(this.paymentSchedule.data, 1);
        });
        
      }
      
    },
    formatCurrency(value) {

      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

    },
    generateSchedule: function(payment_term_details, rounding_rule_id) {

      let schedule = {
        amount: this.principle,
        deposit: 0,
        start_date: this.dataStartDate == '' ? this.$moment().clone().format('YYYY-MM-DD') + "" : this.dataStartDate,
        decimal_calc_type_id: rounding_rule_id,
        custome_schedule: payment_term_details.map(function(item) {
                            return item['display'];
                          })
      };

      // console.log(schedule);

      scheduleService.custom(schedule)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.dataSchedule = response.data;
              console.log(JSON.stringify(this.dataSchedule));
           }
          
        });

    },

    getPaymentTerm(event) {

      this.paymenttermData.data.splice(this.paymenttermData.data.findIndex(function(i){
          return i.is_customized == 1;
      }), 1);

      let data = this.paymenttermData.data;

      data.unshift(event);
      this.paymenttermData.data = data;
      this.dataPaymentTerm = event.id;

      this.generateSchedule(data[0].payment_term_details, data[0].rounding_rule_id);
    },
    handlePayment: function(id) {
      this.$router.push({
        path: "/general/payment/add",
        query: { "scheduleid": id },
      });
    },

    loadingSettings: function(setting) {

      this.customerList = {data: setting.customers};
      this.projectList = {data: setting.projects};
      this.propertyList = {data: setting.properties};
      this.paymenttermList  = {data: setting.paymentterms};
      this.templeteList = {data: setting.templates.filter((item) => item.contract_type_id == 2)};
      this.commissionTypeData = {data: setting.commissiontypes};
      this.lastPayTypeData = {data: setting.lastpaytypes};

      this.sellerData = {data: []};
      this.agencyData = {data: []};

      this.sellerData['data'] = setting.sellers.filter(obj => obj.type_id == 1);
      this.agencyData['data'] = setting.sellers.filter(obj => obj.type_id != 1);


      // console.log(JSON.stringify(this.customerData));
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });

      
    },
    commissionTypeChanged: function(event) {

      this.dataCommissionFor = this.commissionTypeData.data.find(obj => { return obj.id == event});
      console.log("Seller", this.dataSeller);
    },

    loadingCommissionData: function() {

      let param = `?clause={"clause":[{"conjuction":"and","commissions.sale_id":{"value":${this.$route.params.id}}}]}`;
    
      commissionService.getList(param)
        .then(response => {
          // console.log(JSON.stringify(response.data));
          this.fetchingStats = true;

          this.existCommission = response.data.length > 0;

          this.commissionData = response;

          // console.log(JSON.stringify(this.commissionData));
        });
    },
    
    saveCommission: function() {

      console.log(this.dataCommissionFor.commission_for);

      if(this.dataCommissionFor.commission_for == 1 && this.dataSeller == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('sale.seller') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(this.dataCommissionFor.commission_for == 2 && this.dataAgency == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('sale.agency') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(this.dataCommissionFor.commission_for == 3 && (this.dataSeller == 0 || this.dataAgency == 0)) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('sale.seller') + ' & ' + i18n.t('sale.agency')  + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } 


      let sale = {
        commission_type_id: this.dataCommission,
        seller_id: this.dataSeller,
        seller_agency_id: this.dataAgency,
        commission_status_id: 1,
      };

      console.log(JSON.stringify(sale));

      saleService.addCommission(this.$route.params.id, sale)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });

    },

    submitSave: function() {

      // console.log(JSON.stringify(this.seller));
      
      this.tryingToSubmit = true;

      let sale = {
        code: this.dataCode,
        customer_id: this.dataCustomer,
        template_id: this.dataTemplate,
        // payment_account_id: this.dataAccountTender,
        // property_id: this.dataProperty,
        // currency_id: this.dataCurrency,
        // amount: this.dataAmount,
        // discount: this.dataDiscount,
        // discount_type: this.dataDiscountType,
        // sale_price: this.dataSalePrice,
        // deposit: this.dataBookingAmount,
        // interest: this.dataInterest,
        payment_term_id: this.dataPaymentTerm,
        manual_settle: this.dataManualSettle,
        // booking_id: this.dataBooking,
        // commission_type_id: this.dataCommission,
        // sale_user_id: this.dataUserSeller == 0 ? this.user.id : this.dataUserSeller,
        // seller_id: this.dataSeller == 0 && this.seller ? this.seller.id : this.dataSeller,
        // seller_agency_id: this.dataAgency == 0 && this.seller ? this.seller.id : this.dataAgency,
        sale_date: this.dataDate,
        // sale_attachments: this.dataDoc,
        // payment_method_id: this.dataPaymentMethod,
        exclude_deposit: this.dataExcludeDeposit,
        last_pay_type_id: this.dataLastPaytype,
        no_interest_duration: this.dataNoInterestDuration,
        no_interest_payment: this.dataNoInterestPayment

      };

      console.log(this.$route.params.id, JSON.stringify(sale));

      saleService.update(this.$route.params.id, sale)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "sale-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });
        }
      });

    },

    deleted: function(id) {

      this.existCommission = false;

      commissionService.remove(id)
        .then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });

            this.existCommission = false;

          } else {
            this.existCommission = true;
          }
        });
    },
  }
};
</script>

<template>
  <Layout>
   <PageHeader :items="[{
        text: $t('sale.text'),
        href: '/general/customer',
      }, this.breadCrumb]" :title="this.title" />
    <Loading :loaded="fetchingStats" />
    <PaymentTerm 
      id="payment-term"
      ref="payment-term"
      :title="'viewTitle'"
      @save="getPaymentTerm"
      v-model="selectChangePaymentTerm"
    /> 
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0" style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-cart bx-tada font-size-20 align-middle me-2"></i>
                    {{$t('customer.general')}}
                  </div>
                </template>

                <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <h4 class="card-title">{{$t('sale.text')}}</h4>
                      <p class="mb-4">{{$t('sale.sub-text')}}</p>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <Input 
                          :type="'text'"
                          :id="'code'"
                          v-model="dataCode"
                          :label="'sale.code'" 
                          :disabled="true"
                          /> 
                      </div>
                      <div class="col-md-3">
                        <Input 
                          :type="'date'"
                          :id="'sale_date'"
                          v-model="dataDate"
                          :label="'general.date'" 
                          :require="true"
                          /> 
                      </div>
                      <div class="col-md-3">
                        <Select 
                          :text="'name'"
                          :id="'template_id'"
                          v-model="dataTemplate"
                          :list="this.templeteList"
                          :label="'sale.contract-template'"
                          :require="true"
                          /> 
                      </div>
                      <div class="col-md-3">
                        <Search 
                          :id="'customer_id'"
                          :editable="false"
                          v-model="dataCustomer"
                          :list="this.customerList"
                          :require="true"
                          :label="'customer.text'"  />
                      </div>
                    </div>
                    <div class="row">
                      <div class="mb-1"><hr/></div>
                      <h4 class="card-title">{{$t('sale.payment-property')}}</h4>
                      <p class="mb-4"> {{$t('sale.sub-payment-property')}}</p>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <Select
                          @change="projectChanged" 
                          :id="'project_id'"
                          :auto="true"
                          :editable="false"
                          v-model="dataProject"
                          :list="this.projectList"
                          :label="'property.project'"
                          /> 
                      </div>
                      <div class="col-lg-4">
                        <Search 
                          :id="'property_id'"
                          :editable="false"
                          v-model="dataProperty"
                          :list="this.propertyList"
                          :require="true"
                          :label="'property.text'"  />
                      </div>
                      <div class="col-lg-4">
                        <Input 
                          :type="'number'"
                          :id="'sale_price'"
                          :disabled="true"
                          v-model="dataSalePrice"
                          :last="currency"
                          :label="'sale.price'"  />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <Input 
                          :type="'number'"
                          :id="'no_interest_payment'"
                          v-model="dataNoInterestPayment"
                          :label="'sale.no-interest-payment'"  />
                      </div>
                      <div class="col-lg-4">
                        <Input 
                          :type="'number'"
                          :id="'no_interest_duration'"
                          v-model="dataNoInterestDuration"
                          :last="currency"
                          :label="'sale.no-interest-duration'"  />
                      </div>
                      <div class="col-lg-4">
                        <Select 
                          :id="'last_pay_type'"
                          :required="true"
                          v-model="dataLastPaytype"
                          :list="this.lastPayTypeData"
                          :label="'sale.last-pay-type'"  />
                      </div>
                    </div>
                    <div class="row">
                      
                      <div class="col-lg-4">
                        <Input 
                          :type="'number'"
                          :id="'deposit'"
                          :disabled="true"
                          :editable="true"
                          v-model="dataBookingAmount"
                          :last="currency"
                          :label="'sale.deposit'"  />
                      </div>
                      <div class="col-lg-4">
                        <div class="row">
                          <div class="col-lg-8">
                            <Input 
                              :type="'number'"
                              :id="'discount'"
                              :editable="true"
                              v-model="dataDiscount"
                              :last="this.dataDiscountText"
                              :label="'sale.discount'"  />
                          </div>
                          <div class="col-lg-4">
                            <Select
                              @change="discountTypeChanged" 
                              :text="'name'"
                              :id="'discount_type'"
                              :auto="true"
                              v-model="dataDiscountType"
                              :list="this.discountTypeList"
                              :label="'sale.as'"
                              /> 
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <Input 
                          :type="'number'"
                          :id="'amount'"
                          :disabled="true"
                          v-model="dataAmount"
                          :last="currency"
                          :label="'sale.amount'"  />
                      </div>
                      
                    </div>

                    <div class="row">
                      <div class="col-lg-12">

                        <div inline class="row gy-2 gx-3 align-items-end">
                          <div class="col-sm-auto">
                            <Button v-bind:icon="'bx bx-x-circle'" 
                              v-bind:buttonType="'button'"
                              v-bind:variant="'danger'"
                              @click="submitCancel()"
                              v-bind:title="$t('general.cancel')"  />
                          </div>
                          <div class="col-sm-auto">
                            <Button v-bind:icon="'bx bx-save bx-tada'" 
                              v-bind:buttonType="'button'"
                              @click="submitSave()"
                              v-bind:requesting="tryingToSubmit"
                              v-bind:title="$t('general.save')"  />
                          </div>
                        </div>
          
                      </div>
                    </div>
                  </div>
                </b-form>
              </b-tab>
              <!-- <b-tab style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-table font-size-20 align-middle me-2"></i>
                    {{$t('sale.payment-schedule-text')}}
                  </div>
                </template>
      
                <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
                  <div class="col-8">
                    <div class="card">
                      <div class="card-body">
                          
                          <div class="row" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #F6F6FF;">
                            <div class="col-md-1">
                              {{$t('sale.schedule.no')}}
                            </div>
                            <div class="col-md-3">
                              {{$t('sale.schedule.date')}}
                            </div>
                            <div class="col-md-2">
                              {{$t('sale.schedule.principal')}}
                            </div>
                            <div class="col-md-2">
                              {{$t('sale.schedule.paid')}}
                            </div>
                            <div class="col-md-1">
                              {{$t('sale.schedule.interest')}}
                            </div>
                            <div class="col-md-2">
                              {{$t('sale.schedule.balance')}}
                            </div>
                             <div class="col-md-1">
                              
                            </div>
                          </div>
                          <div class="row" style="height: 15px;"></div>
                          <div class="row" style="padding-top: 10px; padding-bottom: 10px; border-bottom: 1px solid #F6F6FF;" 
                              v-for="(item, index) in scheduleList.data" :key="index" >
                              <div class="col-md-1">
                                {{index+1}}
                              </div>
                              <div class="col-md-3">
                                {{`${item.pay_date_show} (${item.day_show})`}}
                              </div>
                              <div class="col-md-2">
                                {{formatCurrency(item.principal)}}
                              </div>
                              <div class="col-md-2">
                                {{formatCurrency(item.integer_pay)}}
                              </div>
                              <div class="col-md-1">
                                {{formatCurrency(item.interest)}}
                              </div>
                              <div class="col-md-2">
                                {{formatCurrency(item.balance)}}
                              </div>
                              <div class="col-md-1">
                                <Button v-show="item.note == 'Pending' || item.note == 'Some'" v-bind:icon="'bx bx-dollar-circle'" 
                                    v-bind:buttonType="'button'"
                                    @click="handlePayment(item.id)"
                                    v-bind:variant="'primary'"   />
                              </div>
                          </div>
                          <div class="row" style="height: 15px;"></div>
                      
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-8">
                            <h4 class="card-title mb-4">{{$t('property.change-term')}}</h4>
                          </div>
                        </div>
                        
                        <div class="row">
                          <div class="col-md-12">
                            <Input 
                                :type="'number'"
                                :id="'principle'"
                                :disabled="true"
                                v-model="principle"
                                :last="'USD'"
                                :label="'sale.amount'"  />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <Select 
                                :id="'payment_term_id'"
                                :text="'name'"
                                :required="true"
                                v-model="dataPaymentTerm"
                                :list="this.paymenttermData"
                                @change="paymenttermChange"
                                :label="'sale.payment-term'"  />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <Input 
                                :type="'date'"
                                :id="'start_date'"
                                v-model="dataStartDate"
                                :label="'general.start-date'"  />
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <Button v-bind:icon="'bx bx-x-circle'" 
                                    v-bind:buttonType="'button'"
                                    v-bind:variant="'danger'"
                                    @click="submitCancel()"
                                    v-bind:title="$t('general.cancel')"  />
                          </div>
                          <div class="col-md-6">
                            <Button v-bind:icon="'bx bx-save bx-tada'" 
                                    v-bind:buttonType="'button'"
                                    @click="submitSave()"
                                    v-bind:requesting="tryingToSubmit"
                                    v-bind:title="$t('general.save')"  />
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </b-form> 

              </b-tab> -->
              <b-tab class="border-0" style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-dollar-circle font-size-20 align-middle me-2"></i>
                    {{$t('commission.text')}}
                  </div>
                </template>

                <b-form v-show="fetchingStats" class="row">
                  <div v-if="existCommission" class="col-lg-12">
                    <List v-bind:dataList="commissionData" 
                        v-bind:updating="fetchingStats" 
                        v-bind:navigate="pageNavigate"
                        v-bind:deletes="[deleted, null]"
                        v-bind:formats="[{name: 'commission', type: 'currency', sign: '$'}, {name: 'commission_paid', type: 'currency', sign: '$'}]"
                        v-bind:fields="[ `code: ${$t('commission.code')}`, `name: ${$t('customer.name')}`, 
                          `sale: ${$t('sale.text')}`, `property: ${$t('property.text')}`, `seller: ${$t('seller.text')}`,
                          `commission: ${$t('commission.commission-amount')}`, `commission_paid: ${$t('commission.commission-paid')}`
                        ]" 
                        v-bind:view="{link: 'customer-view'}"
                        v-bind:more="{
                          sub: [{
                            name: 'invoice.print', icon: 'bx bx-printer', link: 'invoice-request', column: 'id', target: '_blank'
                          },{
                            name: 'commission.paid', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id'
                          }] 
                        }"
                        v-bind:filter="{}"
                        
                    />  
                    
                  </div>
                  <div v-else class="col-lg-12">
                    <div class="row">
                      <div class="col-md-4">
                        <Select 
                            :id="'commission_id'"
                            @change="commissionTypeChanged"
                            v-model="dataCommission"
                            :list="this.commissionTypeData"
                            :label="'booking.commission-type'"  />
                      </div>
                      <div v-show="dataCommissionFor.commission_for == 1 || dataCommissionFor.commission_for == 3" class="col-md-4">
                        <Select 
                            :id="'sale_user_id'"
                            v-model="dataSeller"
                            :list="this.sellerData"
                            :label="'sale.seller'"  />
                      </div>
                      <div v-show="dataCommissionFor.commission_for == 2 || dataCommissionFor.commission_for == 3" class="col-md-4">
                        <Select 
                            :id="'sale_user_id_agency'"
                            v-model="dataAgency"
                            :list="this.agencyData"
                            :label="'sale.agency'"  />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">

                        <div inline class="row gy-2 gx-3 align-items-end">
                          <div class="col-sm-auto">
                            <Button v-bind:icon="'bx bx-x-circle'" 
                              v-bind:buttonType="'button'"
                              v-bind:variant="'danger'"
                              @click="submitCancel()"
                              v-bind:title="$t('general.cancel')"  />
                          </div>
                          <div class="col-sm-auto">
                            <Button v-bind:icon="'bx bx-save bx-tada'" 
                              v-bind:buttonType="'button'"
                              @click="saveCommission()"
                              v-bind:requesting="tryingToSubmit"
                              v-bind:title="$t('general.save')"  />
                          </div>
                        </div>
          
                      </div>
                    </div>
                  </div>  
                </b-form>
              </b-tab>
            </b-tabs>

          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>